/**
 * @file Selfie Station Reducer.
 */

import {
  SELFIE_STATION_SET_ENTITY,
  SELFIE_STATION_RESET,
  SELFIE_STATION_UPLOAD_SELFIE_REQUEST,
  SELFIE_STATION_UPLOAD_SELFIE_SUCCESS,
  SELFIE_STATION_UPLOAD_SELFIE_FAILURE,
} from '../actions/selfie-station-actions';

const initialState = {
  entity: null,
  uploadingSelfie: false,
  error: null,
  creatingRosterIdentity: false,
  rosterIdentityCreateError: null,
};

const selfieStationReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELFIE_STATION_SET_ENTITY:
      return {
        ...state,
        entity: action.entity,
      };

    case SELFIE_STATION_RESET:
      return {
        ...state,
        entity: null,
      };

    case SELFIE_STATION_UPLOAD_SELFIE_REQUEST: {
      return {
        ...state,
        uploadingSelfie: true,
        error: null,
      };
    }

    case SELFIE_STATION_UPLOAD_SELFIE_SUCCESS: {
      return {
        ...state,
        uploadingSelfie: false,
      };
    }

    case SELFIE_STATION_UPLOAD_SELFIE_FAILURE: {
      return {
        ...state,
        uploadingSelfie: false,
        error: action.error,
      };
    }

    default:
      return state;
  }
};

export { initialState };
export default selfieStationReducer;
